import styled from 'styled-components';

const DEFAULT_SIZE = 48;

export const StyledUserOnlineStatusBadge = styled.div<{
    isOnline?: boolean;
    size?: number;
    borderColor?: string;
    onlineColor?: string;
}>`
    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        display: block;
        width: ${props => (props.size || DEFAULT_SIZE) * 0.25}px;
        height: ${props => (props.size || DEFAULT_SIZE) * 0.25}px;
        border-radius: 50%;
        border: ${props => (props.size || DEFAULT_SIZE) * 0.04}px solid ${props => props.borderColor};
        box-sizing: border-box;
        background: ${props => props.onlineColor};
    }
`;
